export default __webpack_public_path__ + "static/media/PenUserMap.38a5b7b1.png";